export const downloadFile = (
    fileData: string,
    fileName: string,
    blobType: string,
    convertToBase64ArrayBuffer: boolean = true
) => {
    const bytes = convertToBase64ArrayBuffer
        ? base64ToArrayBuffer(fileData)
        : fileData
    const blob = new Blob([bytes], {
        type: blobType,
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const getDateForFileName = () => {
    var date = new Date()
    const applyLeadingZero = (num: number) => (num < 10 ? `0${num}` : `${num}`)
    return `${applyLeadingZero(date.getMonth() + 1)}${applyLeadingZero(
        date.getDate()
    )}${date.getFullYear()}_${applyLeadingZero(
        date.getHours()
    )}${applyLeadingZero(date.getMinutes())}${applyLeadingZero(
        date.getSeconds()
    )}`
}

export const base64ToArrayBuffer = (base64: string) => {
    const binaryString = window.atob(base64)
    let bytes = new Uint8Array(binaryString.length)
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binaryString.charCodeAt(i)
    }
    return bytes
}
